import { LinkStatusResponse } from './link-status.types';

export const LINK_STATUS_WINDOW_MS = 12000;
export const LINK_STATUS_INTERVAL_MS = 2500;

export function canMeasure(response: LinkStatusResponse | null | undefined): boolean {
  return response?.state === 'fresh' && response.data?.status === 'active';
}
